import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Date Range")])], -1);
var _hoisted_3 = {
  "class": "px-6 pb-4"
};
var _hoisted_4 = {
  "class": "px-6 pb-4"
};
var _hoisted_5 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 p-4"
};
var _hoisted_6 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  "class": "text-center"
}, "Contacts Added", -1);
var _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  "class": "btn-primary-smaller"
}, "Show", -1);
var _hoisted_9 = {
  key: 0,
  "class": "pill suspend",
  style: {
    "width": "80px"
  }
};
var _hoisted_10 = {
  "class": "text-center capitalize"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_date_picker = _resolveComponent("el-date-picker");
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Data Creation"
  }), _createElementVNode("table", _hoisted_1, [_hoisted_2, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_3, [_createVNode(_component_el_date_picker, {
    modelValue: $data.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.date = $event;
    }),
    type: "daterange",
    "unlink-panels": "",
    "range-separator": "To",
    "start-placeholder": "Start date",
    "end-placeholder": "End date",
    shortcuts: $options.shortcuts,
    size: 'default',
    "disabled-date": $options.dateDisabled,
    "value-format": "YYYY-MM-DD",
    onChange: $options.dateChange
  }, null, 8, ["modelValue", "shortcuts", "disabled-date", "onChange"])]), _createElementVNode("td", _hoisted_4, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 rounded-md",
    type: "button",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.reset && $options.reset.apply($options, arguments);
    })
  }, "Reset")])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_breadcrumb, null, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tabsData, function (tab, tab_key) {
        return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
          onClick: function onClick($event) {
            return $options.goBack(tab, tab_key);
          }
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(tab.user_name), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 256))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_table, {
    data: $data.userStat,
    style: {
      "width": "100%"
    },
    onRowClick: $options.showAccountStatData
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "Resource Details"
      }, {
        "default": _withCtx(function (scope) {
          return [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(scope.row.user_name), 1)]), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(scope.row.user_email), 1)])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, null, {
        header: _withCtx(function () {
          return [_hoisted_7];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "contact_count",
            label: "Total",
            sortable: ""
          }), _createVNode(_component_el_table_column, {
            prop: "existing_count",
            label: "Existing Company",
            sortable: ""
          })];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "company_count",
        label: "Companies Added",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        label: "Account Level"
      }, {
        "default": _withCtx(function (scope) {
          return [_hoisted_8];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        label: "User Status"
      }, {
        "default": _withCtx(function (scope) {
          return [!scope.row.is_active ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Disabled")) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data", "onRowClick"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showTenantStat,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.showTenantStat = $event;
    }),
    top: "5vh",
    center: ""
  }, {
    header: _withCtx(function () {
      return [_createElementVNode("h4", _hoisted_10, "Account wise stats ( " + _toDisplayString($data.selectedUser) + " )", 1)];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.accountLevelStat,
        style: {
          "width": "100%"
        },
        "max-height": "500"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "tenant_id",
            label: "Account"
          }), _createVNode(_component_el_table_column, {
            prop: "contact_count",
            label: "Total Contacts Added",
            sortable: ""
          }), _createVNode(_component_el_table_column, {
            prop: "company_count",
            label: "Total Companies Added",
            sortable: ""
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["modelValue"])])]);
}